import PropTypes from "prop-types";
import { publicConfig } from "@lululemon/ecom-core";
import cs from "classnames";
import { IconTextList } from "@lululemon/dsp-legacy-shared";
import styles from "./contact-us.module.scss";
import {
  STORE_DETAILS_EXPERIENTIAL,
  STORE_DETAILS_REGULAR
} from "../../content/analytics-tags";
import getFormattedPhoneNumber from "../../util/get-formatted-phone-number";

const ContactUsContent = ({ fullAddress, email, phone, isExperiential }) => {
  const directionsLink = `${publicConfig.googleMapsSearchDomain}${fullAddress}`;

  const linkAttributesExperiential = {
    "data-component-link": STORE_DETAILS_EXPERIENTIAL
  };

  const linkAttributesRegular = {
    "data-component-link": STORE_DETAILS_REGULAR
  };

  const linkAttributesByStoreType = isExperiential
    ? linkAttributesExperiential
    : linkAttributesRegular;

  const contactLinksContent = [
    {
      iconName: "location",
      text: fullAddress,
      href: directionsLink,
      linkAttributes: linkAttributesByStoreType
    },
    {
      iconName: "email",
      text: email,
      href: `mailto:${email}`,
      linkAttributes: linkAttributesByStoreType
    },
    {
      iconName: "phone",
      text: `${getFormattedPhoneNumber(phone)}`,
      href: `tel:${phone}`,
      linkAttributes: linkAttributesByStoreType
    }
  ];

  return (
    <IconTextList
      isLink
      listItems={contactLinksContent}
      containerClass={cs(styles.contactInfo, "OneLinkNoTx")}
      iconClass={styles.contactInfoIcon}
    />
  );
};

ContactUsContent.propTypes = {
  fullAddress: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  isExperiential: PropTypes.bool.isRequired
};

export default ContactUsContent;
